import { useLayoutEffect, useRef, useState } from 'react';

// One play per mounted hero. Scroll/resize/parent updates do not restart it.
export const useHeroReveal = () => {
  const ref = useRef(null), played = useRef(false);
  const [motion, setMotion] = useState('waiting');
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;
    let observer, disposed = false, visible = false, fontsReady = !document.fonts;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const showImmediately = () => {
      played.current = true;
      observer?.disconnect();
      if (!disposed) setMotion('complete');
    };
    const reveal = () => {
      if (disposed || played.current || !visible || !fontsReady || document.visibilityState === 'hidden') return;
      played.current = true;
      observer?.disconnect();
      setMotion('playing');
    };
    const preferenceChanged = () => { if (reduced.matches) showImmediately(); };
    if (reduced.matches || !('IntersectionObserver' in window)) showImmediately();
    else {
      observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; reveal(); }, { threshold: 0.1 });
      observer.observe(node);
      if (document.fonts) document.fonts.ready.then(() => { fontsReady = true; reveal(); });
    }
    document.addEventListener('visibilitychange', reveal);
    if (reduced.addEventListener) reduced.addEventListener('change', preferenceChanged);
    else reduced.addListener(preferenceChanged);
    return () => {
      disposed = true; observer?.disconnect();
      document.removeEventListener('visibilitychange', reveal);
      if (reduced.removeEventListener) reduced.removeEventListener('change', preferenceChanged);
      else reduced.removeListener(preferenceChanged);
    };
  }, []);
  const animationEnded = event => {
    if (event.animationName === 'lxtHeroEmphasis') setMotion('complete');
  };
  return { ref, motion, animationEnded };
};